import React from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import colors from 'utils/colors';
import { CategoryLabel, RequiredLabel } from 'components/styled-components';

export const CategorySelect = ({
  categories,
  value,
  handleAnswerCategoryChange,
}) => (
  <React.Fragment>
    <CategoryLabel>
      Display Category <RequiredLabel>(required)</RequiredLabel>
    </CategoryLabel>
    <Select
      options={categories}
      isMulti
      styles={colourStyles}
      value={value}
      components={makeAnimated()}
      onChange={handleAnswerCategoryChange}
      getOptionLabel={option => option.categoryName}
      getOptionValue={option => option.categoryID}
    />
  </React.Fragment>
);

const colourStyles = {
  multiValue: styles => {
    const color = colors.primary;
    return {
      ...styles,
      backgroundColor: color,
      color: 'white',
    };
  },
  multiValueLabel: styles => ({
    ...styles,
    color: 'white',
  }),
};
